import { IItem } from '@bimser/core';
import { Radio, RadioChangeEvent } from 'antd';
import classNames from 'classnames/bind';
import * as React from 'react';
import { BCInputSearch, findMessage, IInputChangeEventArgs } from '..';
import Styles from './assets/radioStyles.scss';
import { IRadioButtonGroupProps, IRadioButtonGroupSelectedChangeEventArgs } from './entities';

const cx = classNames.bind(Styles);

const RadioButton = Radio.Button;

const BCRadioButtonGroup: React.FC<IRadioButtonGroupProps> = props => {
	const [searchQuery, setSearchQuery] = React.useState<string>('');

	const selectedChanged = (e: RadioChangeEvent) => {
		props.onChange({ senderArgs: e, data: e.target.value });
	};

	const onSearch = (_value: IInputChangeEventArgs | string) => {
		const val = typeof _value === 'string' ? _value : _value.data;

		setSearchQuery(val.toLocaleLowerCase());
		props.onSearch?.(val);
	};

	const renderSearchbox = () => {
		if (props.showSearch) {
			return (
				<div
					className={
						props.mode === 'horizontal'
							? Styles.searchBoxHorizontal
							: Styles.searchBoxVertical
					}
				>
					<BCInputSearch
						placeHolder={findMessage.get('100002')}
						readOnly={props.disabled}
						onSearch={onSearch}
						onChange={onSearch}
						size="middle"
					/>
				</div>
			);
		}
	};

	const getOptions = (options: Array<IItem>) => {
		if (!options) {
			return null;
		}

		const classname = cx({
			vertical: props.mode === 'vertical',
			horizontal: props.mode === 'horizontal',
			disabled: props.disabled
		});

		const filteredOpts = options.filter(({ text }) =>
			text.toLocaleLowerCase().includes(searchQuery)
		);

		if (props.buttonType === 'button') {
			return filteredOpts.map(item => (
				<RadioButton
					key={item.key}
					className={classname}
					style={props.style}
					value={item.value}
					disabled={props.disabled}
				>
					<span style={{ whiteSpace: 'nowrap' }}>{item.text}</span>
				</RadioButton>
			));
		}

		return filteredOpts.map(item => (
			<Radio
				key={item.key}
				className={classname}
				style={props.style}
				value={item.value}
				disabled={props.disabled}
			>
				{item.text}
			</Radio>
		));
	};

	const getContainerClassNames = () => {
		const isHorizontal = props.mode === 'horizontal';

		return cx({
			radioGroupContent: isHorizontal,
			containerClassName: isHorizontal
		});
	};

	const onChange = (e: RadioChangeEvent) => {
		if (!props.readOnly && props.onChange) {
			selectedChanged(e);
		}
	};

	return (
		<div className={getContainerClassNames()}>
			{renderSearchbox()}
			<Radio.Group
				className={props.className}
				onChange={onChange}
				disabled={props.disabled}
				value={props.value}
				style={props.style}
				buttonStyle={props.buttonStyle}
			>
				{getOptions(props.options)}
				{props.children}
			</Radio.Group>
		</div>
	);
};
export default BCRadioButtonGroup;
export { IRadioButtonGroupProps, IRadioButtonGroupSelectedChangeEventArgs, RadioButton };
